import React from "react";

import styles from "../../ElectoralGeographyPage.module.styl";

const Card = ({ icon, title, subtitle, children }) => {
  const Icon = icon;

  return (
    <section className={styles.card}>
      <header className={styles.cardHeader}>
        <div className={styles.cardTitleRow}>
          <div className={styles.cardIconWrap}>
            <Icon className={styles.cardIcon} />
          </div>

          <div className={styles.cardHeaderText}>
            <h2>{title}</h2>
            {subtitle ? <div>{subtitle}</div> : null}
          </div>
        </div>
      </header>

      <div className={styles.cardBody}>
        {children}
      </div>
    </section>
  );
};

export default Card;
